@for (
  buildingBlock of blocks;
  track trackBlock($index, buildingBlock);
  let first = $first;
  let last = $last
) {
  <span>
    @switch (buildingBlock.collection) {
      @case ('ampersandAndText') {
        <ss-www-ampersand-and-text
          [ampersandAndTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-ampersand-and-text>
      }
      @case ('carousels') {
        <ss-www-carousel
          [carouselData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-carousel>
      }
      @case ('faqs') {
        <ss-www-faqs
          [faqData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-faqs>
      }
      @case ('floatingTiles') {
        <ss-www-floating-tiles
          [floatingTileData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-floating-tiles>
      }
      @case ('heroImage') {
        <ss-www-hero-media
          [heroImageData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [priority]="first"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-hero-media>
      }
      @case ('heroVideo') {
        <ss-www-hero-media
          [heroVideoData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-hero-media>
      }
      @case ('infoModals') {
        <ss-www-info-modal
          [modalData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
        ></ss-www-info-modal>
      }
      @case ('jotformBlock') {
        <ss-www-jotform-block
          [jotformBlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-jotform-block>
      }
      @case ('jumpToSections') {
        <ss-www-jump-to-section
          [jumpToSection]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-jump-to-section>
      }
      @case ('largeItemCards') {
        <ss-www-large-item-cards
          [largeItemCardsData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-large-item-cards>
      }
      @case ('promoBlock') {
        <ss-www-promo-block
          [promoBlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-promo-block>
      }
      @case ('promoModals') {
        <ss-www-promo-modal
          [modalData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
        ></ss-www-promo-modal>
      }
      @case ('starDivider') {
        <ss-www-star-divider
          [starDividerData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-star-divider>
      }
      @case ('imageTiles') {
        <ss-www-image-tiles
          [imageTileData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-image-tiles>
      }
      @case ('sideBySideImageText') {
        <ss-www-side-by-side-image-text
          [sideBySideImageTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-side-by-side-image-text>
      }
      @case ('textCTA') {
        <ss-www-text-cta
          [textCTAData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-text-cta>
      }
      @case ('textBlock') {
        <ss-www-text-block
          [textBlockData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-text-block>
      }
      @case ('nowPlaying') {
        <ss-www-now-playing
          [nowPlayingData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-now-playing>
      }
      @case ('smallCards') {
        <ss-www-small-cards
          [smallCardsData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-small-cards>
      }
      @case ('sideBySideCarouselAndText') {
        <ss-www-side-by-side-carousel-text
          [sideBySideCarouselAndTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-side-by-side-carousel-text>
      }
      @case ('textByTextCard') {
        <ss-www-text-by-text-card
          [textByTextCardData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="setLastItemFooterBackground ? last : false"
        ></ss-www-text-by-text-card>
      }
      @case ('infoCarousel') {
        <ss-www-info-carousel
          [infoCarouselData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last ? last : false"
        ></ss-www-info-carousel>
      }
      @case ('donationRequestForm') {
        <ss-www-donation-request-form
          [donationRequestFormData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-donation-request-form>
      }
      @case ('sideBySideCarouselDynamicText') {
        <ss-www-side-by-side-carousel-dynamic-text
          [sideBySideCarouselAndDynamicTextData]="buildingBlock.item"
          [id]="buildingBlock.collection + '-' + buildingBlock.item?.id"
          [lastBlock]="last"
        ></ss-www-side-by-side-carousel-dynamic-text>
      }
    }
  </span>
}
